/**
 * Barrel: outline / bordered buttons.
 * Same component as ../ReusableButton — use variant="outline".
 */
import ReusableButton from '../ReusableButton/ReusableButton.js';

export default ReusableButton;
export { ReusableButton };
